module.exports = __webpack_public_path__ + "static/media/U2.49307dd3.png";